import { useEffect, useState } from 'react'
import FilterItemMapper from './FilterItemMapper'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'
import { TBpObject } from './ConvertFilterDisplayText'

export type TGetFilterVal = {displayText: string, selectedValues: any, keyValue: number | null, bpObject?: TBpObject}

const GenericFilters = ({
    responseFilterValues,
    filterableId,
    bpdropDownOptions,
    currentHLDataType,
    isBusinessParameterReplace,
    selectedParameters,
    Addmethod,
}: {
    responseFilterValues: any
    filterableId: any
    bpdropDownOptions: IBusinessParamsOptions[]
    currentHLDataType: any
    isBusinessParameterReplace: 0 | 1
    selectedParameters: any
    Addmethod: (filterArgs: TGetFilterVal) => void
}) => {
    const [selectedId, setSelectedId]= useState<number| null>(null)

    const getFilterValues = (props: TGetFilterVal) =>{
      Addmethod({displayText: props.displayText, selectedValues: props.selectedValues, keyValue: selectedId, bpObject: props.bpObject})
    }

    useEffect(()=>{
      if(selectedParameters.data){
        setSelectedId(parseInt(selectedParameters.data.filterValueListId))
      }
    },[])
    return (
        <>
        {responseFilterValues && responseFilterValues.length > 0 ? (
          <ul className="filtervalue-list filtervalue-list-single">
            {responseFilterValues.map((filterValue: any, filterIndex: number) => (
              <FilterItemMapper
                selectedItem={selectedId}
                key={`filterMapper_${filterableId}_${filterIndex}`}
                filterValue={filterValue}
                filterableId={filterableId}
                bpdropDownOptions={bpdropDownOptions}
                currentHLDataType={currentHLDataType}
                isBusinessParameterReplace={isBusinessParameterReplace}
                GetFilterValues={getFilterValues}
                setSelectedId={setSelectedId}
                selectedParameters={selectedParameters}
                MetadataId={filterValue.MetaDataId}
              />
            ))}
          </ul>
        ) : <>
          No data found {currentHLDataType}. Select another filter.
        </>}
      </>
    )
}

export default GenericFilters
